import React from 'react';
import ViewerStore from '../../stores/ViewerStore';
import * as Inovx from '@shared';
import ViewerActions from '../../actions/ViewerActions';
import { ChangeEventArgs, HtmlEditor, Inject, RichTextEditorComponent, Toolbar } from '@syncfusion/ej2-react-richtexteditor';
import annotationActions from '../../actions/AnnotationActions';
const { useState, useEffect, useRef } = React;

var InovxControls = Inovx.Shared.Controls;
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var SystemActions = Inovx.Shared.System.Actions;

interface AnnotationTextEditorProps {
    onClose?: () => void;
    left: number;
    top: number;
    target?: string;
    class?: string;
}

const AnnotationTextEditor = React.forwardRef((props: AnnotationTextEditorProps, ref) => {
    const rteRef = useRef(null);
    const [selectedKVTag, setSelectedKVTag] = useState<IViewAnnotationTag>(null);

    const [viewerPosition, setViewerPosition] = useState({ 'transform': `translate3d(-1000px,-1000px,0)` });
    const [editorPosition, setEditorPosition] = useState({ x: 500, y: 200 });
    const [selectedAnnotation, setSelectedAnnotation] = useState<string>(ViewerStore.getSelectedAnnotation());
    const [annotationEditorMode, setAnnotationEditorMode] = useState(ViewerStore.getAnnotationEditorMode())
    const [annotationChange, setAnnotationChange] = useState(false);
    const updateViewerState = () => {
        if (ViewerStore.isPanoViewerVisible() || ViewerStore.is3DViewerVisible()) {
            setAnnotationEditorMode(ViewerStore.getAnnotationEditorMode())
            setSelectedAnnotation(ViewerStore.getSelectedAnnotation())
        }
    }
    const resetAnnotationEditorMode = () => {
        setTimeout(() => {
            ViewerActions.setAnnotationEditorMode(false)
        }, 1)
    }
    useEffect(() => {
        if (annotationEditorMode) {
            //setAnnotationEditorMode(false);
            //resetAnnotationEditorMode();
        }
        const kvTagsInfo: any = ViewerStore.getSelectedKnowledgeView()?.Tags;
        const selectedAnnotation = ViewerStore.getSelectedAnnotation();
        const _selectedKVTag = kvTagsInfo?.find((tag: any) => tag.ID == selectedAnnotation);
        setSelectedKVTag(_selectedKVTag)
        stylePopup();
        const handleViewerStoreChange = () => {
            updateViewerState();
        };
        ViewerStore.addChangeListener(handleViewerStoreChange);
        return () => {
            ViewerStore.removeChangeListener(handleViewerStoreChange);
        }
    }, [selectedAnnotation]);
    const confirmSave = () => {
        _saveNote(true);
    }
    const discardChanges = () => {
        ViewerActions.setAnnotationEditorMode(false);
        ViewerActions.resetAnnotation();
        setAnnotationChange(false)
        props.onClose()
    }
    const _closeOpenNote = () => {
        if (annotationChange) {
            SystemActions.displaySaveChangesDialog({
                message: InovxLoader.t("common:msgBox.saveChanges"),
                confirmCallback: confirmSave,
                cancelCallback: discardChanges
            });
        } else {
            ViewerActions.setAnnotationEditorMode(false);
            ViewerActions.resetAnnotation();
            props.onClose()
        }
        
    }
    const editorChange = (e: ChangeEventArgs) => {
        if (e.name === 'change') {
            let annotation = selectedKVTag;
            const newText = e.value;
            if (annotation.Text != newText) {
                setAnnotationChange(true)
            } else {
                setAnnotationChange(false)
            }
        }
    }
    const _saveNote = async (popupClose: boolean = false) => {
        if (!annotationChange) return;
        if (rteRef.current) {
            let annotation = selectedKVTag;
            const newText = rteRef.current.value;

            // Only update the annotation if the text has actually changed
            if (annotation.Text != newText) {
                annotation.Text = newText;
                await ViewerActions.editAnnotation(annotation);
                setAnnotationChange(false)
                if (popupClose) {
                    ViewerActions.resetAnnotation();
                    props.onClose()
                }
            }
        }
    }
    const _updateNotePosition = (e: Event, data: any) => {
        setEditorPosition({ x: data.deltaX, y: data.deltaY })
    }

    const toolbarSettings: object = {
        enable: annotationEditorMode,
        items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
            'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
            'Alignments', 'Outdent', 'Indent', '|',
            'Undo', 'Redo'],
        type: 'Scrollable'
    };

    var cmdList = [
        <i title={InovxLoader.t("facility:action.saveAnnotation")} className={`fa fa-save ${!annotationChange ? 'disabled' : ''}`} onClick={() => _saveNote()} key="edit-note-save"></i>,
        <i title={InovxLoader.t("facility:action.close")} className='fa fa-times' onClick={_closeOpenNote} key="cancel-modal"></i>,
    ];
       
    var classes = ["edit-notes", "open-note"];
    var defaultWidth = 500;
    var defaultHeight = 280;

    const styleEditorPopup = () => {
        let panoViewerWidth = $(`${props.target ? props.target : "#pano-viewer"}`).width();
        let panoViewerHeight = $(`${props.target ? props.target : "#pano-viewer"}`).height();
        if (defaultWidth) {
            let left = props.left;
            let top = props.top;

            // Adjust left position based on icon position
            if (left + ((defaultWidth+15)/2) > panoViewerWidth) {
                left = panoViewerWidth - defaultWidth - 20;
            } else {
                left = props.left - (defaultWidth / 2);
            }

            // Adjust top position based on icon position
            if ((top + defaultHeight + 25) > panoViewerHeight) {
                let offset = (panoViewerHeight - top) + 25
                top = panoViewerHeight - defaultHeight - offset;
            } else {
                top = props.top + 20;
            }
            if (props.target) {
                left = left - 50;
                top = top - 50;
            }
            return { x: left, y: top }
        }
    }
    const stylePopup = () => {
        setTimeout(() => {//added setTimeout because RichTextEditorComponent rendered content when click on other info icon when one is open
            let panoViewerWidth = $(`${props.target ? props.target : "#pano-viewer"}`).width();
            let panoViewerHeight = $(`${props.target ? props.target : "#pano-viewer"}`).height();
            let containerWidth = $('#view-annotation').width();
            let containerHeight = $('#view-annotation').height();
            if (containerWidth) {
                let left = props.left;
                let top = props.top;

                // Adjust left position based on icon position
                if (left + ((containerWidth+25)/2) > panoViewerWidth) {
                    left = panoViewerWidth - containerWidth - 25;
                } else {
                    left = (props.left - 5) - (containerWidth / 2);
                }

                // Adjust top position based on icon position
                if ((top + containerHeight+30) > panoViewerHeight) {
                    let offset = (panoViewerHeight - top) + 35
                    top = panoViewerHeight - containerHeight - offset;
                } else {
                    top = props.top + 20;
                }
                setViewerPosition({ 'transform': `translate3d(${left}px, ${top}px, 0)` });
            }
        }, 10);
    }
    return (annotationEditorMode ?
        <div className="opened-note-container" id="edit-annotation">
            <InovxControls.DraggablePanel containerClass={classes} minDimensions={{ x: 400, y: 384 }}
                commandList={cmdList}
                defaultSize={{ x: defaultWidth, y: defaultHeight }}
                //bounds={editorPosition}
                initialPosition={styleEditorPopup()}
                onDrag={_updateNotePosition}
            >
                <div className='edit-notes-container' >
                    <RichTextEditorComponent
                        ref={rteRef}
                        autoSaveOnIdle={true}
                        saveInterval={100}
                        change={editorChange}
                        //created={styleEditorPopup}
                        value={selectedKVTag?.Text}
                        height={defaultHeight-35}
                        toolbarSettings={toolbarSettings}>
                        <Inject services={[Toolbar, HtmlEditor]} />
                    </RichTextEditorComponent>
                </div>
            </InovxControls.DraggablePanel>
        </div>
            :
        <div className={`annotation-detail-container ${props?.class || ''}`} style={viewerPosition} id="annotation-container">
            <div className='view-annotation' id="view-annotation">
                <RichTextEditorComponent
                    created={stylePopup}
                    ref={rteRef}
                    readonly={true}
                    value={selectedKVTag?.Text}
                    toolbarSettings={toolbarSettings}>
                    <Inject services={[Toolbar, HtmlEditor]} />
                </RichTextEditorComponent>
            </div>
        </div>)
});

export default AnnotationTextEditor;